import styled from 'styled-components';
import { H1, P, Link as A } from 'components/Typography';
import Container from 'components/Container';
import { th } from 'style/theme';
import { sizes } from 'style';

export const NotFoundContainer = styled(Container)`
  padding-bottom: 0;
  padding-top: 160px;
  height: 100%;
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    min-height: 50vh;
  }

  @media ${sizes.largeDesktop} {
    padding-top: 40px;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    margin-left: 50px;
    margin-right: 50px;
    flex-direction: ${(props) => (props.isReversed ? 'row-reverse' : 'row')};
    justify-content: ${(props) => (props.isReversed ? 'space-evenly' : 'space-between')};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${sizes.tabletPortrait} {
    min-width: 50%;
    margin-top: -90px;
  }

  @media ${sizes.desktop} {
    min-width: 500px;
  }
`;

export const Title = styled(H1)`
  font-size: 50px;
  line-height: 0.9;
  color: ${th('colors.white')};

  @media ${sizes.tabletPortrait} {
    font-size: 9vw;
  }

  @media ${sizes.tabletLandscape} {
    font-size: 10vw;
  }

  @media ${sizes.largeDesktop} {
    font-size: 126px;
  }
`;

export const SubTitle = styled(P)`
  margin-top: 15px;
  font-size: 17px;
  max-width: 60%;
  font-weight: normal;
  color: ${th('colors.white')};

  @media ${sizes.tabletPortrait} {
    font-size: 17px;
    max-width: 100%;
  }
  @media ${sizes.desktop} {
    font-size: 28px;
    max-width: 100%;
  }
`;

export const Link = styled(A)`
  margin-top: 30px;
  font-size: 16px;
  font-weight: normal;
  max-width: max-content;
  z-index: 1;

  @media ${sizes.desktop} {
    font-size: 22px;
  }
`;

export const Image = styled.div`
  display: flex;
  align-items: ${(props) => (props.imageOnBottom ? 'flex-end' : 'center')};

  > img {
    display: block;
    width: 100%;
    height: auto;

    @media ${sizes.tabletPortrait} {
      margin-right: 40px;
      min-width: 300px;
    }

    @media ${sizes.tabletLandscape} {
      margin-left: ${(props) => (props.isReversed ? '40px' : '0')};
      max-width: 60%;
    }

    @media ${sizes.desktop} {
      display: inline;
      max-width: 100%;
      margin: initial;
    }
  }

  @media ${sizes.desktop} {
    display: flex;
    align-items: center;
    max-width: 550px;
    margin-top: 70px;
    margin-right: 40px;
    margin-left: -250px;
  }
`;
